<script setup lang="ts">
</script>

<template>
    <stf-container full>
        MENU
    </stf-container>
    <stf-container>
        <slot></slot>
    </stf-container>
    <stf-container>
        FOOTER
    </stf-container>
</template>

<style scoped>

</style>
